export const DEFAULT_MIME_TYPE = 'application/octet-stream';
export const DEFAULT_SERVER_BASE_PATH = '/Commander';
export const SUPPORTED_PROTOCOLS_REGEX = /http.*/g;
export const WS_BASE_URL = '/ws/commander';
export const Z_INDEX_ALERTS = 300000;

/**
 * This is a pattern to match a string formatted like GUID, but not necessarily having a valid GUID value.
 * (The range of allowed values in a GUID is well-known and can be more strict.)
 */
export const GUID_FORMAT_PATTERN = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';
export const GUID_FORMAT_REGEX = new RegExp(GUID_FORMAT_PATTERN, 'i');
